/**
 * Refcounted body scroll lock. Multiple concurrent overlays (modal,
 * drawer, sheet) can each `acquire` and `release`; the body's
 * `overflow:hidden` is only cleared once the last lock is released.
 *
 * It also set an `et-filters-open` class, whose ONLY job was hiding the
 * bottom bar behind an open drawer. That bar was deleted 2026-09-05 and its
 * rules went with it, so the class styled nothing and is gone too — don't
 * reintroduce a marker class without a rule that reads it.
 *
 * Without this, two overlays opening together race on cleanup —
 * whichever closes first wipes the lock for the other.
 *
 * Server-safe: all DOM access is guarded.
 */

let lockCount = 0;

function isClient() {
  return typeof document !== "undefined";
}

export function acquireBodyScrollLock(): void {
  if (!isClient()) return;
  lockCount += 1;
  if (lockCount === 1) {
    document.body.style.overflow = "hidden";
  }
}

export function releaseBodyScrollLock(): void {
  if (!isClient()) return;
  if (lockCount === 0) return; // defensive — no-op if already cleared
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = "";
  }
}
